import { render, staticRenderFns } from "./NumericView.vue?vue&type=template&id=bc4d52f8&scoped=true"
import script from "./NumericView.vue?vue&type=script&lang=js"
export * from "./NumericView.vue?vue&type=script&lang=js"
import style0 from "./NumericView.vue?vue&type=style&index=0&id=bc4d52f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4d52f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
